module.exports = __webpack_public_path__ + "img/hovertip.190f03e5.svg";